var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"product_service_container pc_container"},[_c('banner'),_c('platformOperationProcess'),_c('authorizationDetail')],1),_c('div',{staticClass:"mobile_container"},[_c('mobile-product-service')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }